import { useQuery } from "@apollo/client";
import cn from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";

import { BUS_STOPS } from "@api/queries/bus-stops";
import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import EmptySlider from "@components/cms/EmptySlider/EmptySlider";
import { useStore } from "@hooks/useZustandProvider";
// import { useMousePosition } from "@hooks/useMousePosition";
import Container from "@ui-kit/Container/Container";

// import Loading from "@ui-kit/Loading/Loading";
import s from "./StopsBlock.module.scss";

const StopsBlock = ({ settings, data, updateField }) => {
  const { locale } = useRouter();
  const { t } = useTranslation();
  // const { isWidget } = useMousePosition();
  const { cms, updateBlockIndex, updateModals, updateCollectionType } =
    useStore();
  const { isWidget } = cms.page;
  const { isWidgetEditing } = cms.widget;
  const { isEditMode } = cms.uiOptions;
  const { title, collections } = data;
  const { blockType } = settings.common;
  const { items, type } = collections.stops;
  const { lang } = cms.page;
  const [busStops, setBusStops] = useState([]);

  const cursorNotice = "Double click to edit stops";

  const handleClickToEdit = (e) => {
    switch (e.detail) {
      // case 1: // click
      // break;
      case 2: // double click
        updateCollectionType(e);
      // break;
      // case 3: // triple click
      // break;
    }
  };

  const filteredItems = items.filter((item) => {
    return typeof item.isShow === "boolean" ? item.isShow : true;
  });

  const { loading } = useQuery(BUS_STOPS, {
    skip: !filteredItems.length,
    variables: {
      ids: filteredItems.map((i) => i.stopId),
      lang: isEditMode ? lang : locale,
    },
    onCompleted: (data) => {
      setBusStops(data?.busStops || []);
    },
  });

  useEffect(() => {
    if (!filteredItems.length) {
      setBusStops([]);
    }
  }, [filteredItems.length]);

  return (
    <Container className={s.stopsBlock}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          {!!busStops.length ? (
            <div
              className={s.stopsWrap}
              {...(isEditMode && !(!isWidgetEditing && isWidget)
                ? {
                    "data-cursor-notice": cursorNotice,
                    "data-collection-type": type,
                    onClick: handleClickToEdit,
                  }
                : {})}
            >
              <div className={cn(s.shadow, s.left)} />
              <div className={cn(s.shadow, s.right)} />
              <div className={s.stops}>
                {busStops?.map(
                  (
                    {
                      BusStopId,
                      Address = {
                        Street: "",
                        ZipCode: "",
                        CityName: "",
                      },
                      Coordinates = {
                        Latitude: "",
                        Longitude: "",
                      },
                      BusStopName,
                      HasPriority = false,
                    },
                    key,
                  ) => {
                    const {
                      Street = "",
                      ZipCode = "",
                      CityName = "",
                    } = Address;
                    const { Latitude = "", Longitude = "" } = Coordinates;

                    return (
                      <div
                        key={BusStopId}
                        className={cn(
                          s.stop,
                          (key === 0 || key + 1 === busStops?.length) &&
                            s.firstLast,
                        )}
                      >
                        <div className={s.line}>
                          <div className={s.dot} />
                          {key + 1 !== filteredItems.length && (
                            <div className={s.l} />
                          )}
                        </div>
                        <h5>{BusStopName}</h5>
                        <Link
                          href={`https://www.google.com/maps/search/?api=1&query=${Latitude},${Longitude}`}
                          className={s.onMap}
                          target="_blank"
                        >
                          {t("open in google maps")}
                        </Link>
                        {!!Street && (
                          <div className={s.address}>
                            {Street}
                            {!!ZipCode && `, ${ZipCode}`}
                            {!!CityName && `, ${CityName}`}
                          </div>
                        )}
                        {/* {!HasPriority && (
                            <div className={s.dropOff}>
                              {t('drop off-on request')}
                            </div>
                          )} */}
                      </div>
                    );
                  },
                )}
              </div>
            </div>
          ) : isEditMode ? (
            <EmptySlider
              cursorNotice={cursorNotice}
              collectionType={type}
              onClick={handleClickToEdit}
            />
          ) : null}
        </section>
      </Container>
    </Container>
  );
};

export default StopsBlock;
